import { CostCalculation } from '@forms/CostCalculation'
import { useIsLaptop } from '@hooks/use-media-query'

import { ApplicationMap } from './ApplicationMap'
import { Description } from './Description'
import { Header } from './Header'
import { Results } from './Results'
import { ScopeOfWork } from './ScopeOfWork'
import { UserResearch } from './UserResearch'
import { VisualDesign } from './VisualDesign'
import { Wireframes } from './Wireframes'

export function Design991() {
  const isLaptop = useIsLaptop()

  return (
    <>
      <Header />
      <Description />
      <ScopeOfWork />
      <UserResearch />
      {isLaptop && <ApplicationMap />}
      <Wireframes />
      <VisualDesign />
      <Results />
      <CostCalculation />
    </>
  )
}
